import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },

  inputContainer: {
    width: '100%',
    paddingBottom: 8,
    borderBottom: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`
  },

  tab: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    textTransform: 'capitalize'
  },

  tabPanel: {
    paddingTop: theme.spacing(2)
  },

  card: {
    display: 'flex',
    flexDirection: 'row',
    gap: 16,
    alignItems: 'center',
    padding: 16,
    borderRadius: 8,
    backgroundColor: theme.app.colors.input.background,
    cursor: 'pointer',
    transition: 'background 0.2s',
    '&:hover': {
      backgroundColor: theme.app.colors.input.backgroundStrong
    }
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,

    '& span:first-child': {
      fontWeight: 500,
      color: theme.palette.primary.main,
      fontSize: theme.app.typography.body.fontSize
    },

    '& span:last-child': {
      fontWeight: 500,
      color: '#000',
      fontSize: theme.app.typography.label.fontSize
    }
  },
  notFound: {
    fontStyle: 'italic',
    color: alpha(theme.palette.primary.main, 0.7),
    textAlign: 'center',
    marginTop: 32
  },

  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxHeight: 450,
    overflowY: 'auto'
  }
}))
